import * as yup from 'yup';
import { emailDomain } from './Constants';
import { BUSINESS_NAME } from '@/utils/constants';
import { regexEightDigitsLicense, regexFullLicense } from '@/queue/ducks/validationSchema';

export const profileSchema = yup.object({
    contact_email: yup.string().email("Invalid email address").trim().nullable().transform((latestValue, fieldValue) => (fieldValue === '' ? null : latestValue)),
    store_contact_fax: yup.string().trim().nullable().transform((latestValue, fieldValue) => (fieldValue === '' ? null : latestValue)).matches(/^[0-9]{10}$/, "Invalid fax number"),
    contact_phone: yup.string().matches(/^[0-9]{10}$/, "Invalid phone number").required("Enter your contact number"),
    store_premise_zip_code: yup.string().matches(/^[0-9]{5}$/, "Enter 5 digit zip code!").required(),
    store_premise_state: yup.string().trim().required("Enter your state!"),
    store_premise_city: yup.string().trim().required("Enter your city!"),
    store_premise_street: yup.string().trim().required("Enter your street!"),
    name: yup.string().trim().required(`Enter your ${BUSINESS_NAME}!`),
    seller_email: yup.string().email("Invalid email address").trim().required("Email is required").transform((latestValue, fieldValue) => (fieldValue === '' ? null : `${latestValue}${emailDomain}`)),
})

export const createStoreSchema = yup.object({
  contact_email: yup.string().email("Invalid email address").trim().nullable().transform((latestValue, fieldValue) => (fieldValue === '' ? null : latestValue)),
  store_contact_fax: yup.string().trim().nullable().transform((latestValue, fieldValue) => (fieldValue === '' ? null : latestValue)).matches(/^[0-9]{10}$/, "Invalid fax number"),
  store_premise_zip_code: yup.string().matches(/^[0-9]{5}$/, "Enter 5 digit zip code!"),
  store_premise_state: yup.string().trim(),
  store_premise_city: yup.string().trim(),
  store_premise_street: yup.string().trim(),
  store_license_key: yup.string().trim().matches(/^[0-9]{8}$/, "Invalid license number").required("Enter license number!"),
  seller_email: yup.string().email("Invalid email address").trim().required("Email is required").transform((latestValue, fieldValue) => (fieldValue === '' ? null : `${latestValue}${emailDomain}`)),
})

export const emailSchema = yup.object({
  email: yup.string().email("Please enter a valid email").trim()
});

export const phoneNumberSchema = yup.object({
  phone: yup.string().matches(/^[0-9]{10}$/, "Please enter a valid phone number")
});

export const websiteSchema = yup.object({
  web_url: yup.string().url("Please enter a valid website URL").trim()
});

export const contactSchema = yup.object({
  contact: yup.string().trim()
});

export const getTextFeildSchema = (fiedName: string) => yup.object({
  [fiedName]: yup.string().trim()
});

export const userSchema = yup.object({
  email: yup.string().email("Please enter a valid email.").required("Please enter email.").max(64, "Email must be at most 64 characters").trim(),
  firstName: yup.string().required("Please enter first name.").required().max(90, "First name must be at most 90 characters").trim(),
  lastName: yup.string().required("Please enter last name.").max(90, "Last name must be at most 90 characters").trim(),
  groupName: yup.string().required("Please select a role."),
  phone: yup.string().matches(/^[0-9]{10}$/, "Please enter a valid phone number").required("Enter your phone number"),
  isMFAEnabled: yup.boolean().required("Please specify if MFA is enabled.")
})

export const editUserSchema = yup.object({
  firstName: yup.string().required("Please enter first name.").required().max(90, "First name must be at most 90 characters").trim(),
  lastName: yup.string().required("Please enter last name.").max(90, "Last name must be at most 90 characters").trim(),
  groupName: yup.string().required("Please select a role."),
  accountStatus: yup.string().required("Please select a account statu."),
  phone: yup.string().matches(/^[0-9]{10}$/, "Please enter a valid phone number").required("Enter your phone number"),
})

export const storeConfigurationSchema = yup.object({
  geocodingMapKey: yup.string().required("Please enter geocoding map key.").max(100, "Geocoding map key must be at most 100 characters").trim(),
  selectTransferWebhook: yup.string().url("Please enter a valid URL").max(90, "Webhook url must be at most 100 characters").trim(),
  selectAdminconfiguationwebhook: yup.string().url("Please enter a valid URL").max(90, "Url must be at most 100 characters").trim(),
})

export const storeConfigurationMagentoSchema = yup.object({
  geocodingMapKey: yup.string().required("Please enter geocoding map key.").max(100, "Geocoding map key must be at most 100 characters").trim(),
  selectTransferWebhook: yup.string().required("Please enter a url.").url("Please enter a valid URL").max(90, "Webhook url must be at most 100 characters").trim(),
  selectAdminconfiguationwebhook: yup.string().required("Please enter a url.").url("Please enter a valid URL").max(90, "Url must be at most 100 characters").trim(),
})

export const createNewStoreSchema = yup.object({
  is_multi_tenant: yup.boolean().default(false),
  store_license_key: yup.string().trim().when('is_multi_tenant', {
    is: true,
    then: (schema) => schema.test(
      'license-validation-optional',
      'License Number must be at most 8 or 20 characters',
      (value) => {
        if (!value) return true;
        return regexFullLicense.test(value) || regexEightDigitsLicense.test(value);
      }
    ),
    otherwise: (schema) => schema.required("License number is required.").test(
      'license-validation',
      'License Number must be at most 8 or 20 characters',
      (value) => {
        return regexFullLicense.test(value) || regexEightDigitsLicense.test(value);
      }
    )
  }),
  sender_email: yup.string().email("Invalid email address").trim().required("Email is required").transform((latestValue, fieldValue) => (fieldValue === '' ? null : `${latestValue}${emailDomain}`)),
  // store_domain: yup.string()
})

export const fflSelectConfigurationSchema = yup.object({
  fflTransferApiUrl: yup.string().url("Please enter a valid URL").max(90, "Transfer api url must be at most 100 characters").trim(),
  selectUrl: yup.string().url("Please enter a valid URL").max(90, "Store url must be at most 100 characters").trim(),
  transferAuthUrl: yup.string().url("Please enter a valid URL").max(90, "Store url must be at most 100 characters").trim(),
  storeAuthUrl: yup.string().url("Please enter a valid URL").max(90, "Store url must be at most 100 characters").trim(),
  selectSDKURL: yup.string().url("Please enter a valid URL").max(90, "Store url must be at most 100 characters").trim(),
})

export const fflStripeCustomerIdSchema = yup.object({
  customerId: yup.string().required("Please enter customer id.").max(90, "Customer id must be at most 100 characters").trim(),
})

